"use client";
import React from "react";
import { SessionProvider, SessionProviderProps } from "next-auth/react";
import { Session } from "next-auth";

interface NextAuthSessionProviderProps {
	children?: React.ReactNode;
	session?: Session | null;
}
const NextAuthSessionProvider: React.FC<NextAuthSessionProviderProps> = ({
	children,
	session,
}) => {
	return <SessionProvider session={session}>{children}</SessionProvider>;
};
export default NextAuthSessionProvider;
